import vpnBlogImage from '@/assets/vpn/vpn-blog-1.png';
import yesMoviesImage from '@/assets/vpn/yesmovies-alternatives.png';
import boxingImage from '@/assets/vpn/boxing-live-stream.png';
import fmoviesAlternativesImage from '@/assets/vpn/fmovies-alternatives-cover.png';
import nordVpnVsExpressVpnImage from '@/assets/vpn/nordvpn-vs-expressvpn-cover.png';

export const proxyRows = [
  { ip: '39.68.66.152', port: '1080', country: 'CN', protocol: 'SOCKS5', anonymity: 'Elite' },
  { ip: '27.65.29.247', port: '1080', country: 'VN', protocol: 'SOCKS4', anonymity: 'Elite' },
  { ip: '95.182.78.3', port: '5678', country: 'UA', protocol: 'SOCKS4', anonymity: 'Elite' },
  { ip: '141.11.32.241', port: '3128', country: 'NL', protocol: 'HTTPS', anonymity: 'Transparent' },
  { ip: '145.220.226.161', port: '8080', country: 'NL', protocol: 'HTTP', anonymity: 'Elite' },
  { ip: '202.28.194.139', port: '31280', country: 'TH', protocol: 'HTTPS', anonymity: 'Elite' },
  { ip: '45.143.108.115', port: '8080', country: 'GE', protocol: 'HTTP', anonymity: 'Transparent' },
  { ip: '202.6.193.11', port: '12345', country: 'ID', protocol: 'HTTP', anonymity: 'Transparent' },
  { ip: '154.12.231.66', port: '8888', country: 'US', protocol: 'HTTPS', anonymity: 'High' },
  { ip: '34.44.49.215', port: '80', country: 'US', protocol: 'HTTP', anonymity: 'Elite' },
  { ip: '49.0.0.175', port: '1080', country: 'ID', protocol: 'SOCKS5', anonymity: 'Elite' },
  { ip: '217.160.162.25', port: '8888', country: 'DE', protocol: 'HTTPS', anonymity: 'Transparent' },
  { ip: '180.191.59.10', port: '8081', country: 'PH', protocol: 'HTTPS', anonymity: 'Transparent' },
  { ip: '27.68.175.42', port: '1080', country: 'VN', protocol: 'SOCKS4', anonymity: 'Elite' },
  { ip: '89.43.132.219', port: '8080', country: 'TR', protocol: 'HTTPS', anonymity: 'Transparent' },
  { ip: '184.181.178.33', port: '4145', country: 'US', protocol: 'SOCKS5', anonymity: 'Elite' },
  { ip: '222.127.132.13', port: '8080', country: 'PH', protocol: 'HTTP', anonymity: 'Transparent' },
];

export const anonymityRows = [
  {
    level: 'Elite (High Anonymity)',
    alias: 'Level 1',
    seesRealIp: 'No',
    knowsProxy: 'No',
    useCase: 'High-security web scraping, account management, anti-bot bypass.',
  },
  {
    level: 'Anonymous',
    alias: 'Level 2',
    seesRealIp: 'No',
    knowsProxy: 'Yes',
    useCase: 'General web browsing, location spoofing, public data harvesting.',
  },
  {
    level: 'Transparent',
    alias: 'Level 3',
    seesRealIp: 'Yes',
    knowsProxy: 'Yes',
    useCase: 'School/corporate caching, bandwidth saving (not suitable for privacy).',
  },
];

export const nordVpnComparisonRows = [
  {
    option: 'Free trial',
    payAtSignup: '$0 with eligible offer',
    length: 'Usually 7 days on current offer',
    next: 'Paid subscription unless canceled',
  },
  {
    option: '30-day guarantee',
    payAtSignup: 'Yes',
    length: 'Up to 30 days',
    next: 'Request refund if eligible',
  },
  {
    option: 'Free VPN plan',
    payAtSignup: 'No',
    length: 'Unlimited',
    next: 'Not available',
  },
];

export const yesMoviesComparisonRows = [
  {
    option: 'Tubi',
    type: 'Free',
    bestFor: 'Free movies & TV',
    content: 'Horror, crime, action, anime, classics',
  },
  {
    option: 'Pluto TV',
    type: 'Free',
    bestFor: 'Live TV + movies',
    content: 'Movies, classic TV, comedy, news',
  },
  {
    option: 'Plex',
    type: 'Free',
    bestFor: 'Streaming + personal media',
    content: 'Movies, TV shows, personal media',
  },
  {
    option: 'Roku Channel',
    type: 'Free',
    bestFor: 'Free TV & live channels',
    content: 'Movies, TV, news, live channels',
  },
  {
    option: 'Xumo Play',
    type: 'Free',
    bestFor: 'Casual free streaming',
    content: 'Movies, live TV, family, comedy',
  },
  {
    option: 'Netflix',
    type: 'Paid',
    bestFor: 'Original series',
    content: 'Drama, crime, reality, anime, international',
  },
  {
    option: 'Prime Video',
    type: 'Paid',
    bestFor: 'Movies + rentals',
    content: 'Movies, TV, originals, rentals',
  },
  {
    option: 'Disney+',
    type: 'Paid',
    bestFor: 'Franchise content',
    content: 'Disney, Pixar, Marvel, Star Wars',
  },
  {
    option: 'Max',
    type: 'Paid',
    bestFor: 'Premium TV',
    content: 'HBO, Warner Bros., DC, dramas',
  },
  {
    option: 'Paramount+',
    type: 'Paid',
    bestFor: 'TV & sports',
    content: 'CBS, comedy, reality, Nickelodeon, sports',
  },
];

export const yesMoviesFreePaidRows = [
  { service: 'Tubi', price: 'Free', bestFor: 'Movies, horror, crime, anime' },
  { service: 'Pluto TV', price: 'Free', bestFor: 'Live TV and movies' },
  { service: 'Plex', price: 'Free', bestFor: 'Streaming + personal media' },
  { service: 'Roku Channel', price: 'Free', bestFor: 'Movies and live channels' },
  { service: 'Xumo Play', price: 'Free', bestFor: 'Casual watching and live TV' },
  { service: 'Netflix', price: 'Paid', bestFor: 'Original series and movies' },
  { service: 'Prime Video', price: 'Paid', bestFor: 'Movies, rentals and TV' },
  { service: 'Disney+', price: 'Paid', bestFor: 'Disney, Marvel, Star Wars' },
  { service: 'Max', price: 'Paid', bestFor: 'HBO and premium TV' },
  { service: 'Paramount+', price: 'Paid', bestFor: 'CBS, comedy, reality and sports' },
];

export const boxingComparisonRows = [
  { platform: 'DAZN', bestFor: 'Dedicated boxing fans', focus: '★★★★★', free: 'No' },
  { platform: 'ESPN+', bestFor: 'US sports fans', focus: '★★★★☆', free: 'No' },
  { platform: 'Prime Video', bestFor: 'Big events and sports', focus: '★★★★☆', free: 'No' },
  { platform: 'Fubo', bestFor: 'Live sports and PPV', focus: '★★★★☆', free: 'No' },
  { platform: 'Peacock', bestFor: 'NBC sports fans', focus: '★★★☆☆', free: 'No' },
  { platform: 'Paramount+', bestFor: 'Zuffa Boxing and CBS sports', focus: '★★★★☆', free: 'No' },
  { platform: 'Netflix', bestFor: 'Major boxing events', focus: '★★★★☆', free: 'No' },
  { platform: 'YouTube', bestFor: 'Free official coverage', focus: '★★★☆☆', free: 'Sometimes' },
  { platform: 'TNT Sports', bestFor: 'UK sports fans', focus: '★★★★☆', free: 'No' },
  { platform: 'Sky Sports', bestFor: 'UK boxing', focus: '★★★★★', free: 'No' },
];

export const blogPosts = [
  {
    title: 'Is NordVPN Free? How to Get the NordVPN Free Trial in 2026',
    description:
      'Is NordVPN free in 2026? Learn how the NordVPN free trial works, how long it lasts, what happens after the trial, and free VPN alternatives.',
    url: '/is-nordvpn-free-how-to-get-free-trial/',
    date: 'August 26, 2026',
    image: vpnBlogImage,
  },
  {
    title: '10 Best YesMovies Alternatives in 2026: Legal Free and Paid Options',
    description:
      'Looking for a YesMovies alternative? See the best free and paid streaming sites in 2026, what each is best for, and how Secure VPN can help with regional access.',
    url: '/10-best-yesmovies-alternative-legal/',
    date: 'September 10, 2026',
    image: yesMoviesImage,
  },
  {
    title: 'Boxing Live Stream: 10 Best Ways to Watch Boxing Online in 2026',
    description:
      'Want to watch a boxing fight live? Find where to stream major boxing events, which platforms offer the best coverage, and what to check before the fight starts.',
    url: '/10-platforms-to-watch-boxing-live-stream/',
    date: 'September 10, 2026',
    image: boxingImage,
  },
  {
    title: '10 Best Legal FMovies Alternatives for Watching Movies Online',
    description:
      'Looking for FMovies alternatives? Compare 10 legal movie streaming services, including free options like Tubi and Pluto TV and paid platforms like Netflix.',
    url: '/10-best-fmovies-alternatives-free-legal-sites/',
    date: 'September 14, 2026',
    image: fmoviesAlternativesImage,
  },
  {
    title: 'NordVPN vs ExpressVPN for Streaming: Which Is Better?',
    description:
      'Compare NordVPN and ExpressVPN for streaming, including region coverage, Netflix, 4K quality, stability, speed, and support for popular streaming services.',
    url: '/nordvpn-vs-expressvpn-for-streaming-which-is-better/',
    date: 'September 14, 2026',
    image: nordVpnVsExpressVpnImage,
  },
];

export const resourceImages = {
  nordVpnArticle: vpnBlogImage,
  yesMoviesArticle: yesMoviesImage,
  boxingArticle: boxingImage,
};
